'use strict';

var _objectSpread = require("/home/agency21/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _classCallCheck = require("/home/agency21/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/agency21/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/home/agency21/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/agency21/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/agency21/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var Container = require('./container');
var LazyResult, Processor;
var Document = /*#__PURE__*/function (_Container) {
  _inherits(Document, _Container);
  function Document(defaults) {
    var _this;
    _classCallCheck(this, Document);
    // type needs to be passed to super, otherwise child roots won't be normalized correctly
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Document).call(this, _objectSpread({
      type: 'document'
    }, defaults)));
    if (!_this.nodes) {
      _this.nodes = [];
    }
    return _this;
  }
  _createClass(Document, [{
    key: "toResult",
    value: function toResult() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var lazy = new LazyResult(new Processor(), this, opts);
      return lazy.stringify();
    }
  }]);
  return Document;
}(Container);
Document.registerLazyResult = function (dependant) {
  LazyResult = dependant;
};
Document.registerProcessor = function (dependant) {
  Processor = dependant;
};
module.exports = Document;
Document.default = Document;